<div class="tank-approvals-container">
  <div class="status-info">
    <div class="icon">
      <fa-icon class="base" [class.success]="approvalOperationLead()" [icon]="icons.faShield"></fa-icon>
      <div class="centered">
        <fa-icon [icon]="approvalOperationLead() ? icons.faCheck : icons.faXmark"></fa-icon>
      </div>
    </div>
    <span class="info">Aprobado por líder de operaciones</span>
  </div>

  <div class="status-info">
    <div class="icon">
      <fa-icon class="base" [class.success]="approvalBussinessUnitDirector()" [icon]="icons.faShield"></fa-icon>
      <div class="centered">
        <fa-icon  [icon]="approvalBussinessUnitDirector() ? icons.faCheck : icons.faXmark"></fa-icon>
      </div>
    </div>
    <span class="info">Aprobado por director de unidad de negocio</span>
  </div>

  <div class="status-info">
    <div class="icon">
      <fa-icon class="base" [class.success]="approvalAudit()" [icon]="icons.faShield"></fa-icon>
      <div class="centered">
        <fa-icon [icon]="approvalAudit() ? icons.faCheck : icons.faXmark"></fa-icon>
      </div>
    </div>
    <span class="info">Aprobado por auditoría</span>
  </div>
  @if ([14,15,16].includes(roleId()) &&
  !(
    (this.approvalOperationLead() && roleId() === 14) ||
    (this.approvalBussinessUnitDirector() && roleId() === 15) ||
    (this.approvalAudit() && roleId() === 16)
  ) &&
  this.validateOrder()) {
    <button (click)="approve()" type="button" class="btn btn-zazz-dark ms-2 shadow-sm">Aprobar</button>
  }
  <app-modal-tank-approvals (reload)="reload()" [idTank]="tankId() ?? null"></app-modal-tank-approvals>
</div>
